import type { SegmentKind } from '../types';

const LABELS: Record<SegmentKind, string> = {
  word: 'word',
  filler: 'filler',
  noise: 'noise',
  unclear: 'unclear',
  silence: 'silence',
};

export interface KindBadgeProps {
  kind: SegmentKind;
  className?: string;
}

/** Colored pill showing a segment's kind. Used in Verify, Correct and Done. */
export function KindBadge({ kind, className = '' }: KindBadgeProps) {
  return <span className={`badge badge--${kind} ${className}`.trim()}>{LABELS[kind]}</span>;
}
